import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS} from '@angular/forms';
import {maxValidator} from './max-validator';

@Directive({
    providers: [
        {
            multi: true,
            provide: NG_VALIDATORS,
            useExisting: MaxDirective
        }
    ],
    selector: '[maximum]'
})
export class MaxDirective {
    @Input() public maximum: any;

    constructor() {
    }

    /**
     *
     * @param abstractControl
     */
    public validate(abstractControl: AbstractControl): { [key: string]: any } | null {
        return maxValidator(this.maximum)(abstractControl);
    }
}
